import { render, staticRenderFns } from "./SocialBanSearch.vue?vue&type=template&id=2cb97747&"
import script from "./SocialBanSearch.vue?vue&type=script&lang=js&"
export * from "./SocialBanSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports